import { useMemo } from 'react';
import { tp } from '@/typograf';

export function useTypograf(str: string) {
    return useMemo(() => tp(str), [str]);
}
